import KursTypPage from './KursTypPage';

export default KursTypPage;
